import React, { Fragment, useState } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Button, Card, CardBody, CardFooter, Input, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import PageHeading from "Layout/AppMain/PageHeading";
import ExpandableTable from "./ExpandableTable";
import { ReactComponent as SearchIcon } from "../../../../../assets/utils/images/svgs/search.svg";
import { ReactComponent as AddIcon } from "../../../../../assets/utils/images/svgs/addBlue.svg";
import { useNavigate } from 'react-router-dom';
import useSWR from "swr";
import { useCheckOrCreateBSN, useCommunityContractList, useGenerateBSN } from "Api/Coordinator/Gebruikers";


const LinkPage = () => {
    const [filterData, setFilterData] = useState({
        community: '',
        user: '',
        contractType: '',
    });
    const [search, setSearch] = useState('');
    const [showGebruikersModal, setShowGebruikersModal] = useState(false);
    const [showBSNModal, setShowBSNModal] = useState(false);
    const [bsn, setBsn] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();


    const toggleGebruikersModal = () => {
        setShowGebruikersModal(!showGebruikersModal);
        setError("")
        setBsn("")
    };


    const { trigger: checkBSN } = useCheckOrCreateBSN();
    const { data, mutate } = useGenerateBSN();
    const { data: communitiesResponse } = useCommunityContractList();
    const communities = communitiesResponse?.data || [];

    const contractList =
        communities.find(
            item => String(item.iCommunityId) === filterData.community
        )?.contracttypes || [];

    const filterHandler = (type, value) => {
        setFilterData((prev) => {
            return { ...prev, [type]: value }
        })
    }

    const validateBSN = (value) => {

        const regex = /^[0-9]{0,9}$/;
        if (regex.test(value)) {
            setBsn(value);
            setError("");
        } else {
            setError("BSN moet tussen de 8 en 9 cijfers lang zijn.");
        }
    };

    const checkOrCreateBSN = () => {
        setError("");
        if (bsn.length >= 8 && bsn.length <= 9) {
            checkBSN({
                data: {
                    bsn: bsn
                }
            })
                .then((response) => {

                    if (response.status === false) {
                        setError(" ongeldig");
                    } else {

                        if (response.status === true && response?.exists == 1) {
                            navigate(`/gebruikers/${response.iAdminId}`, {
                                state: { tab: "algemeen" }
                            });
                        }
                        else {
                            setShowGebruikersModal(false)
                            setShowBSNModal(true);
                        }
                    }



                })
                .catch((error) => {
                    console.error("BSN API Error:", error);
                    setError("onjuist")
                });
        } else {
            setError("Please enter a valid BSN with 8 or 9 digits.");
        }
    };
    const generateBSN = () => {
        setError("");
        mutate().then((response) => {
            setBsn(response.bsn);
        })
            .catch((error) => {
                console.error("error", error)
            });
    }

    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <Card className="main-card mb-5 gebruikers-tb">
                    <CardBody className="d-flex flex-column">
                        <div className="form-group">
                            {/* <SearchIcon /> */}
                            <input type="text" className="form-control mb-2 search" placeholder="Zoeken..." onChange={(e) => setSearch(e.target.value)} />
                        </div>
                        <ExpandableTable filterData={filterData} search={search} />
                    </CardBody>
                </Card>
            </TransitionOnLoad>
            <div className="chat-layout-footer verzoken-footer-height">
                <CardFooter className="chat-layout-footer__inner gebruikers-footer">
                     <div className="col-6 d-flex gap-3">
                        <select className={`form-select bestuur-select`} value={filterData.community} onChange={(e) => {
                            filterHandler('community', e.target.value);
                            filterHandler('contractType', '')
                        }}>
                            <option value={''}>Alle besturen</option>
                            {communities?.map(item => {
                                return <option value={item.iCommunityId}>{item.vCommunityName}</option>
                            })}
                        </select>
                        <select className={`form-select bestuur-select`} value={filterData.user} onChange={(e) => { filterHandler('user', e.target.value) }}>
                            <option value={''}>Alle gebruikers</option>
                            <option value='vervanger'>Vervangers</option>
                            <option value='melder'>Melders</option>
                            <option value='coordinator'>Coördinatoren</option>
                        </select>
                        <select className={`form-select select bestuur-select`} value={filterData.contractType} onChange={(e) => { filterHandler('contractType', e.target.value) }}>
                            <option value={''}>Alle contracttypen</option>
                            {contractList?.map(item => {
                                return <option value={item.id}>{`${item.abbr} - ${item.name}`}</option>
                            })}
                        </select>
                        <button className="btn btn-outline-primary btn-color-style d-flex justify-content-center align-items-center gap-2">
                            Excel <AddIcon />
                        </button>
                        <button className="btn btn-outline-primary btn-color-style d-flex justify-content-center align-items-center gap-2" onClick={toggleGebruikersModal}>
                            Gebruiker <AddIcon />
                        </button>
                    </div>
                </CardFooter>
                <Modal
                    isOpen={showGebruikersModal}
                    toggle={toggleGebruikersModal}
                    className="modal-centered contract-type-modal feedback-modal-style link-form"
                >
                    <ModalHeader toggle={toggleGebruikersModal}>
                        Gebruiker toevoegen
                    </ModalHeader>
                    <ModalBody className="text-center mt-4 mb-4">
                        <p>
                            Voer hieronder een BSN in om een gebruiker toe te voegen. Indien deze gebruiker reeds in ons systeem aanwezig is, worden de gegevens opgehaald.
                        </p>

                        <p className="text-start ms-5">BSN</p>
                        <div className="d-flex flex-column align-items-center justify-content-center ">
                            <Input
                                name="clooserUn"
                                data-lpignore="true"
                                autoComplete="off"
                                type="text"
                                className="w-75 d-flex justify-content-center"
                                value={bsn}
                                onChange={(e) => validateBSN(e.target.value)}
                            />
                            {error && <div className="text-danger">{error}</div>}
                        </div>



                    </ModalBody>
                    <ModalFooter className="justify-content-center pt-3">
                        <Button color="link" className="btn-color-style" onClick={checkOrCreateBSN}>
                            BSN opzoeken
                        </Button>
                        <Button
                            color="link"
                            className="btn-color-style"
                            onClick={generateBSN}
                        >
                            Fictief BSN genereren
                        </Button>
                    </ModalFooter>
                </Modal>


                <Modal
                    isOpen={showBSNModal}
                    toggle={() => setShowBSNModal(false)}
                    className="feedback-modal-style role-modal modal-centered"
                >
                    <ModalBody>
                        <p className="mt-5 text-center text-red">
                            De gebruiker heeft geen toegang omdat hij of zij niet is toegevoegd aan de groep geautoriseerde gebruikers.
                        </p>

                        <div className="d-flex align-items-center justify-content-center border-bottom-0 gap-4 py-4">
                            <Button
                                className="btn-color-style opslaan-btn px-4"
                                size="lg"
                                outline
                                color="primary"
                                onClick={() => setShowBSNModal(false)}
                            >
                                OK
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>

            </div>
        </Fragment>
    )
}
export default LinkPage